import { ErrorTemplateTypes } from './types';
export const ErrorTemplateContent: ErrorTemplateTypes = {
    error401: {
        imgUrl: require('../../assets/img/visuel_erreur_503.svg'),
        contentTitle: 'Les services amelipro sont indisponibles !',
        contentText: `Nous mettons en œuvre les mesures nécessaires pour rétablir rapidement votre accès.
        Veuillez nous excuser pour la gêne occasionnée.`,
        btnText: 'Se connecter ',
        errorCode: 401
    },
    error404: {
        imgUrl: require('../../assets/img/visuel_erreur_404.svg'),
        contentTitle: 'Désolé ! La page n’a pas été trouvée !',
        contentText: 'La page que vous essayer d’afficher n’existe plus ou a été déplacée',
        btnText: 'Page d’accueil',
        errorCode: 404
    },
    error500: {
        imgUrl: require('../../assets/img/visuel_erreur_500.svg'),
        contentTitle: 'Les services amelipro sont indisponibles !',
        contentText: `Nous mettons en œuvre les mesures nécessaires pour rétablir rapidement votre accès.
        Veuillez nous excuser pour la gêne occasionnée.`,
        btnText: 'Se connecter ',
        errorCode: 500
    },
    error503: {
        imgUrl: require('../../assets/img/visuel_erreur_503.svg'),
        contentTitle: 'Pour votre confort nous améliorons ce service',
        contentText: `Vous pourrez le retrouver « date et heure de rétablissement du service ».
        Veuillez nous excuser pour la gêne occasionnée.`,
        btnText: 'Page d’accueil',
        errorCode: 503
    },
    disconnect: {
        titleText:'Déconnexion',
        imgUrl: require('../../assets/img/visuel_deconnexion.svg'),
        contentTitle: 'Vous êtes déconnecté(e)',
        contentText: 'Merci pour votre visite, à très bientôt !',
        btnText: 'Se connecter '
    },
    obsolete: {
        titleText:'NAVIGATEUR OBSOLÈTE',
        imgUrl: require('../../assets/img/visuel_navigateur_obsolete.svg'),
        contentTitle: 'Cette version de navigateur est obsolète !',
        contentText:`Nous vous conseillons de télécharger une version plus récente ou de choisir un autre navigateur
        afin d’utiliser nos services de façon optimale et en toute sécurité.`
    },
    inactive: {
        imgUrl: require('../../assets/img/visuel_deconnexion.svg'),
        contentTitle: 'En raison d’inactivité, votre session a expiré !',
        contentText: 'Veuillez nous excuser pour la gêne occasionnée.',
        btnText: 'Se reconnecter '
    }
};
